import React, {ReactNode} from 'react';
import {withTranslation} from 'react-i18next';
import connect from "./store/connect";
import {useStore} from "react-redux";
import {IState} from "./store/reducer";
import MessageProvider from "./provider/MessageProvider";

function AppProvider(props: {children: ReactNode}) {
    const store = useStore<IState>();
    const storeData = store.getState();

    return (
      <MessageProvider>
        {props.children}
      </MessageProvider>
    )
}

export default withTranslation()(connect(AppProvider));
